import { memo } from 'react'

import { useNeedLogo } from '@builddocs/data-management'
import { LogoIcon } from '@builddocs/icons'
import { Link } from 'react-router-dom'

import styles from './LogoButton.module.scss'

type LogoButtonProps = {
  onClick?: () => void
}
const LogoButtonElement = ({ onClick }: LogoButtonProps) => {
  const { withoutLogo } = useNeedLogo()

  return !withoutLogo ? (
    <Link
      className={styles.logoButton}
      to="/sakura"
      type="link"
      onClick={() => onClick?.()}
    >
      <LogoIcon />
    </Link>
  ) : null
}

export const LogoButton = memo(LogoButtonElement)
export default LogoButton
